window.addEventListener('DOMContentLoaded', () => {
   const emailElements = document.querySelectorAll(".hide-email");

   if(emailElements) {
    emailElements.forEach((item) => {

        const email = item.innerText;
        
        item.innerHTML = `<a href='mailto:"${email}"'>${email}</a>`;

        item.classList.remove("hide-email")
    })
   }
   
})